import script from "./IDEA_ACTIVITY_PROMOTED_TO_FEATURE.vue?vue&type=script&setup=true&lang=ts"
export * from "./IDEA_ACTIVITY_PROMOTED_TO_FEATURE.vue?vue&type=script&setup=true&lang=ts"

import "./IDEA_ACTIVITY_PROMOTED_TO_FEATURE.vue?vue&type=style&index=0&id=032cf8e5&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-032cf8e5"]])

export default __exports__